import { cn } from '@/lib/cn'

/*
 * 字标：像素字体写的 PlazaPlus，Plus 用品牌绿 —— 跟 AgentPlus / AlfaPlus 一家的那半截。
 * 颜色跟主题走（ink / brand-ink），深浅两套都读得清。
 * compact 给折叠后只有图标宽的侧栏：只留 P+。
 */
export function Wordmark({
  compact = false,
  className,
}: {
  compact?: boolean
  className?: string
}) {
  return (
    <span
      className={cn('font-pixel text-[23px] leading-none font-bold whitespace-nowrap', className)}
      aria-label="PlazaPlus"
      role="img"
    >
      <span className="text-ink">{compact ? 'P' : 'Plaza'}</span>
      <span className="text-brand-ink">{compact ? '+' : 'Plus'}</span>
    </span>
  )
}
